import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleAddModal, toggleNeedRefresh } from '../../store/userTabSlice';
import Modal from '../../components/components/modal/modal';
import ApiService from '../../components/api_services/apiService';

import './User.css';

function AddUser() {
  const dispatch = useDispatch();

  const isModalOpen = useSelector((state) => state.users.addModalOpen);

  const [formData, setFormData] = useState({
    email: '',
    phoneNumber: '+48',
    role: '',
  });

  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  useEffect(() => {
    const isValid = formData.email.trim() !== '' &&
                    formData.phoneNumber.trim() !== '' &&
                    formData.role.trim() !== '';
    setIsSubmitDisabled(!isValid);
  }, [formData]); // Monitoruj zmiany w `formData`

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const data = {
        email: formData.email,
        phoneNumber: formData.phoneNumber,
        role: formData.role
      };

      const response = await ApiService.addNewUser(data);
      console.log('Nowy sport został dodany:', response);

      dispatch(toggleAddModal());
      dispatch(toggleNeedRefresh());
    } catch (error) {
      console.error('Błąd podczas dodawania nowego sportu:', error);
    }
  };

  const handleCloseModal = () => {
    dispatch(toggleAddModal());
  };

  return (
    <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
      <h2>Dodaj użytkownika</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
            title="Wprowadź poprawny adres email"
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <label htmlFor="phoneNumber">Numer telefonu</label>
          <input
            type="tel"
            id="phoneNumber"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleInputChange}
            pattern="^\+\d{9,15}$"
            title="Numer telefonu w formacie międzynarodowym, np. +48123456789"
            required
          />
        </div>
        <div>
          <label htmlFor="phoneNumber">Rola</label>
          <select
              type="text"
              id="role"
              name="role"
              value={formData.role}
              onChange={handleInputChange}
              required>
            <option value="" disabled>Wybierz rolę...</option>
            <option value="USER">Użytkownik</option>
            <option value="ADMIN">Administrator</option>
          </select>
        </div>
        <div className="modal-margin-top-20">
          <button className="buttons-modal-appearance2-almost-white" type="button" onClick={handleCloseModal}>
            Anuluj
          </button>
          <button type="submit" disabled={isSubmitDisabled}>
            Dodaj
          </button>
        </div>
      </form>
    </Modal>
  );
}

export default AddUser;